export default __webpack_public_path__ + "static/media/conference-room.37321bf5.jpg";